import {
    WorkspaceColumn,
    WorkspaceSortValue,
} from "@common/types/views/workspaceViews";
import { ViewConfig } from "@lib/views";
import { WorkspaceDetails } from "@common/types/workspace";
import { MembersCell } from "./MembersCell";
import { NameCell } from "./NameCell";
import { EntitiesCell } from "./EntitiesCell";

export interface WorkspaceDetailsRow extends WorkspaceDetails {
    id: string;
}

export const workspaceViewConfig: ViewConfig<
    WorkspaceDetailsRow,
    WorkspaceColumn,
    WorkspaceSortValue
> = {
    columns: {
        [WorkspaceColumn.NAME]: {
            accessorKey: "workspace.name",
            name: "Workspace",
            header: "Workspace",
            cell: NameCell,
            sort: {
                asc: WorkspaceSortValue.NAME_ASC,
                desc: WorkspaceSortValue.NAME_DESC,
            },
            minSize: 200,
            maxSize: 600,
        },
        [WorkspaceColumn.ENTITIES]: {
            accessorKey: "workspace.entities",
            name: "Entities",
            header: "Entities",
            cell: EntitiesCell,
            minSize: 160,
            maxSize: 240,
        },
        [WorkspaceColumn.TEAM]: {
            accessorKey: "assignments",
            name: "Team",
            header: "Team",
            cell: MembersCell,
            minSize: 160,
            maxSize: 240,
        },
    },
};
